import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { WrapperPage, ContentPage } from './styled';

interface NotFoundPageProps {
  title?: string;
  subtitle?: string;
}

const NotFoundPage = ({ title = 'Page not found', subtitle = 'Oops!' }: NotFoundPageProps) => {
  const serverError = window.location.href.indexOf('/server-error') > -1;
  const history = useHistory();

  const handleClick = () => {
    history.push('/');
  };
  return (
    <>
      <WrapperPage>
        <ContentPage>
          <h5>{subtitle}</h5>
          <h1>{serverError ? 'Sorry, something went wrong.' : title}</h1>
          <button onClick={handleClick}>Go to the app</button>
        </ContentPage>
      </WrapperPage>
    </>
  );
};

export default NotFoundPage;
